import { useQuery } from '@tanstack/react-query';
import { dbClient, normalizeRpcResponse } from '@/services/db-client';
import type { AdminJornadaRegistrationRow } from '../types';

export function useAdminJornadaRegistrationsList(jornadaSlug: string, search: string) {
    return useQuery<AdminJornadaRegistrationRow[]>({
        queryKey: ['admin', 'jornadas-landing', 'list', jornadaSlug, search],
        queryFn: async () => {
            const params: Record<string, unknown> = {
                p_jornada_slug: jornadaSlug.trim() || null,
                p_search: search.trim() || null,
                p_limit: 500,
                p_offset: 0,
            };
            const { data, error } = await dbClient.rpc('admin_jornada_registrations_list', params);
            if (error) throw new Error(error.message);
            return normalizeRpcResponse(data) as AdminJornadaRegistrationRow[];
        },
        staleTime: 15_000,
    });
}
